import axios, { AxiosError, AxiosInstance } from 'axios';
import { API_URL } from './constants';
import { navigate } from './navigation';

// Routes that should NOT trigger 401 redirect
const UNAUTHORIZED_WHITELIST = [
  '/tooluser/is-etf-user-valid',
  '/tooluser/is-scc-user-valid',
  '/tooluser/etf-login',
  '/tooluser/scc-login',
  '/auth/login', // Avoid redirect loop if login fails
];


const interceptorConfig = (config: any) => {
  const adminToken = sessionStorage.getItem('adminToken'); // Retrieve token from localStorage or other source
  const userToken = adminToken || sessionStorage.getItem('userToken'); // Fallback to sessionStorage

  console.log("user token from db", userToken);

  const token = userToken || adminToken;
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`; // Attach token to Authorization header
  }
  return config;
}

const handleUnauthorized = (error: AxiosError) => {
  const requestUrl = error.config?.url || '';

  // Skip 401 handling for whitelisted routes
  const shouldSkipRedirect = UNAUTHORIZED_WHITELIST.some(route =>
    requestUrl.includes(route)
  );

  if (error.response?.status === 401 && !shouldSkipRedirect) {
    // Clear any existing tokens
    sessionStorage.removeItem('adminToken');
    sessionStorage.removeItem('userToken');

    // Navigate to login page
    navigate('/login'); // Adjust this based on your routing solution
  }
  return Promise.reject(error);
}



let baseUrl = API_URL
const API: AxiosInstance = axios.create({
  baseURL: baseUrl,
});

API.interceptors.request.use(interceptorConfig);

API.interceptors.response.use(
  response => response,
  handleUnauthorized
);

export { API };
